import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {ValueTypeDescriptor} from "#template/runtime-graph/descriptors"

const TD = TypeDescriptors

const ArrayOrElement: ValueTypeDescriptor<any[] | any> = {
    deepCompare: (a, b) => {
        const aIsArray = Array.isArray(a)
        const bIsArray = Array.isArray(b)
        if (aIsArray && bIsArray) {
            if (a.length !== b.length) return false
            for (let i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) return false
            }
            return true
        }
        return a === b
    },
    deepCopy: (a) => {
        if (Array.isArray(a)) {
            return [...a]
        }
        return a
    },
}

const mergeDescriptor = {
    input: TD.inlet(TD.Array(ArrayOrElement)),
    output: TD.outlet(TD.Identity<any>()),
}

export class Merge<T> implements NodeClassImpl<typeof mergeDescriptor, typeof Merge> {
    static descriptor = mergeDescriptor
    static uniqueName = "Merge"
    input!: Inlet<(T | T[])[]>
    output!: Outlet<T[]>

    run() {
        if (this.input === NotReady) {
            this.output.emitIfChanged(NotReady)
            return
        }
        const tmp: T[] = []
        for (const xs of this.input) {
            if (Array.isArray(xs)) {
                for (const x of xs) {
                    tmp.push(x)
                }
            } else tmp.push(xs)
        }
        this.output.emit(tmp)
    }
}
